/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Already_Exists_MessageInputs */

const en_admin_create_company_user_already_exists_message = /** @type {(inputs: Admin_Create_Company_User_Already_Exists_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This user already exists. Confirm to add them to this company.`)
};

const de_admin_create_company_user_already_exists_message = /** @type {(inputs: Admin_Create_Company_User_Already_Exists_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Benutzer existiert bereits. Bestätigen Sie, um ihn diesem Unternehmen hinzuzufügen.`)
};

/**
* | output |
* | --- |
* | "This user already exists. Confirm to add them to this company." |
*
* @param {Admin_Create_Company_User_Already_Exists_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_already_exists_message = /** @type {((inputs?: Admin_Create_Company_User_Already_Exists_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Already_Exists_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_already_exists_message(inputs)
	return en_admin_create_company_user_already_exists_message(inputs)
});